export const cardSx = {
  height: '100%',
  backgroundColor: '#FFFFFF',
  boxShadow: 'none',
  overflow: 'hidden'
};

export const headerContainerSx = {
  p: 0,
  pb: 0
};

export const providerRowSx = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 2
};

export const providerInfoSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
  height: 42
};




export const clinicFormControlSx = {
  minWidth: 320,
  alignItems:'end',

  '& .MuiOutlinedInput-root': {
    height: 38,
    borderRadius: '4px',
    color: '#757575',
    fontSize: 12
  }
};

export const searchIconSx = {
  color: '#9E9E9E',
  fontSize: 20
};

export const filterButtonSx = {
  height: 38,
  px: 2,
  borderRadius: '4px',
  borderColor: '#4E8AC7',
  color: '#4E8AC7',
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'none',

  '&:hover': {
    borderColor: '#4E8AC7',
    backgroundColor: '#F5F9FD'
  },

  '& .MuiButton-startIcon': {
    mr: 0.75
  }
};

export const cardContentSx = {
  p: 0,

  '&:last-child': {
    pb: 0
  }
};

export const tablePaperSx = {
  border: '1px solid #E0E0E0',
  borderRadius: '6px',
  boxShadow: 'none',
  overflow: 'hidden'
};

export const tableSx = {
  tableLayout: 'fixed',

  '& .MuiTableCell-root': {
    px: '14px'
  }
};

export const tableHeadRowSx = {
  height: 40,
  backgroundColor: '#F5F5F5'
};

export const tableBodyRowSx = {
  height: 40,

  '&:hover': {
    backgroundColor: '#FCF8F2'
  }
};

export const headCellSx = {
  height: 40,
  padding: '0 18px',
  borderBottom: '1px solid #E0E0E0',
  backgroundColor: '#FAFAFA',
  color: '#424242',
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 0,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap'
};

export const bodyCellSx = {
  height: 40,
  padding: '0 18px',
  borderBottom: '1px solid #EEEEEE',
  color: '#424242',
  fontSize: 13,
  fontWeight: 400
};

export const patientNameCellSx = {
  ...bodyCellSx,
  fontWeight: 500
};

export const recapButtonSx = {
  p: 0.5,
  color: '#DFB573'
};

export const recapIconSx = {
  fontSize: 20
};

export const paginationSx = {
  borderTop: '1px solid #EAEAEA',

  '& .MuiToolbar-root': {
    minHeight: 40,
    padding: '0 20px',
    backgroundColor: '#F5F5F5'
  },

  '& .MuiTablePagination-selectLabel': {
    color: '#424242',
    fontSize: 13
  },

  '& .MuiTablePagination-displayedRows': {
    color: '#424242',
    fontSize: 13
  },

  '& .MuiSvgIcon-root': {
    fontSize: 20
  }
};

export const popoverPaperSx = {
  width: 500,
  borderRadius: '6px',
  overflow: 'hidden'
};

export const recapHeaderSx = {
  height: 56,
  px: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#F7F9FC',
  borderBottom: '1px solid #E0E0E0'
};

export const recapTitleSx = {
  color: '#424242',
  fontSize: 16,
  fontWeight: 500
};

export const recapDescriptionSx = {
  mt: 0.25,
  color: '#424242',
  fontSize: 14
};

export const closeButtonSx = {
  color: '#424242'
};

export const recapContentSx = {
  maxHeight: 336
};

export const recapFooterSx = {
  height: 48,
  px: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 1,
  borderTop: '1px solid #E0E0E0',
  backgroundColor: '#FAFAFA'
};

export const filterSelectSx = {
  width: 240,
  height: 38,
  bgcolor: '#fff',
  color: '#757575',
  borderRadius: '4px',
  fontSize: 12,

  '& .MuiSelect-select': {
    py: 1
  }
};

export const menuProps = {
  slotProps: {
    paper: {
      sx: {
        width: 240,
        minWidth: '240px !important',
        maxWidth: 240,
        borderRadius: '4px',
        boxShadow: '0px 4px 16px rgba(0,0,0,0.16)',

        '& .MuiMenu-list': {
          p: 0
        },

        '& .MuiMenuItem-root': {
          minHeight: 36,
          fontSize: 12,
          color: '#757575',

          '&:hover': {
            bgcolor: '#FCF8F2'
          },

          '&.Mui-selected': {
            bgcolor: '#fff'
          },

          '&.Mui-selected:hover': {
            bgcolor: '#FCF8F2'
          },

          '&.Mui-focusVisible': {
            bgcolor: '#FCF8F2'
          }
        }
      }
    }
  }
};


export const dataHxContainerSx = {
  width: '100%'
};

export const dataHxTableSx = {
  tableLayout: 'fixed',

  '& .MuiTableCell-root': {
    borderBottom: '1px solid #EEEEEE',
    padding: '0 16px',
    height: 40,
    fontSize: 12,
    color: '#424242'
  }
};

export const dataHxRowSx = {
  cursor: 'pointer',

  '&:hover': {
    bgcolor: '#FCF8F2'
  }
};

export const dataHxDateCellSx = {
  width: 90,
  fontWeight: 500,
  whiteSpace: 'nowrap'
};

export const reviewCardSx = {
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden'
};